import {BaseModel} from "../base";

class SlotModel extends BaseModel {

    constructor(data) {
        super(data);
        this.datetime = moment(data.datetime);
    }

    static $query(company, params) {
        return SlotService.query(company, params);
    }
}

SlotModel.AVAILABLE = 0;
SlotModel.ENQUIRED = 1;
SlotModel.TAKEN = 2;
SlotModel.RESERVED = 2;
SlotModel.BLOCKED = 3;
SlotModel.BOOKED = 4;
SlotModel.UNAVAILABLE = 5;
SlotModel.CANCELLED = 6;
SlotModel.NOT_LIVE = 7;
SlotModel.WAIT = 8;
SlotModel.HELD = 9;
SlotModel.QUEUE = 10;
SlotModel.CREATED_EXTERNALLY = 11;

export {
    SlotModel
}
